<template>
  <div class="employee pb-9">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card class="dialog-card pa-0">
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text class="pt-3">
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >n</v-btn
          >
          <b>افزودن کارمند جدید</b>
        </v-card-text>
        <v-card-subtitle>
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >q</v-btn
          >
          <b>بستن این راهنما</b>
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-card class="common-card">
      <div class="d-flex flex-row">
        <h4 class="c-grey pt-2">کارمندان</h4>
        <v-divider class="me-10 ms-10" vertical></v-divider>
        <div class="custom-input2">
          <v-text-field
            hide-details
            outlined
            dense
            label="جستجو در نام کارمندان..."
            prepend-icon="$Search"
            @input="currentPage = 1"
            v-model="filter"
          >
            <template v-slot:append>
              <v-icon
                v-if="filter.length"
                class="red--text text--lighten-2"
                @click="
                  filter = '';
                  currentPage = 1;
                "
                >mdi-close-circle</v-icon
              >
            </template>
          </v-text-field>
        </div>
      </div>
      <hr class="mt-5" />
      <v-card v-if="loading" flat>
        <div class="d-flex flex-column align-items-center mt-8 py-6">
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            :color="'#EF6C00'"
          />
          <p class="primary--text font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
      </v-card>
      <v-card v-else flat>
        <v-container class="pt-12">
          <v-row>
            <v-col class="d-flex flex-row">
              <h4 class="primary--text">کارمندان فروشگاه</h4>
              <span style="padding-top: 2px" class="c-grey ms-4"
                >({{ employee.length }} کارمند)</span
              >
            </v-col>
            <v-col class="text-left">
              <v-btn
                @click="openNewProduct()"
                @shortkey="openNewProduct()"
                v-shortkey.once="['n']"
                class="orange-borderedBtn"
                height="43"
              >
                <v-icon class="me-1">$Bag</v-icon>افزودن کارمند جدید
              </v-btn>
            </v-col>
          </v-row>
          <hr />
          <div class="custom-table mt-3">
            <b-table
              responsive
              show-empty
              :current-page="currentPage"
              :per-page="perPage"
              :items="computedItems"
              :fields="employeesFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  رکوردی برای نمایش وجود ندارد.
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>

              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(role)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ roles.filter((x) => x.value == data.value)[0].text }}
                </div>
              </template>
              <template v-slot:cell(status)="data">
                <div style="text-align: center; vertical-align: middle">
                  <div
                    class="mx-auto"
                    :class="
                      data.value == 'active' ? 'green-badge' : 'red-badge'
                    "
                  >
                    {{ statuses.filter((x) => x.value == data.value)[0].text }}
                  </div>
                </div>
              </template>
              <template v-slot:cell(operation)="row">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-btn
                    v-if="!row.item._showDetails"
                    @click="row.toggleDetails"
                    class="orange-mainBtn"
                    width="120"
                    >نمایش عملیات</v-btn
                  >
                  <v-btn
                    v-else
                    @click="row.toggleDetails"
                    class="red-mainBtn"
                    width="120"
                    >بستن عملیات</v-btn
                  >
                </div>
              </template>
              <template #row-details="row">
                <div
                  class="animated fadeIn mb-2"
                  style="text-align: center; vertical-align: middle"
                >
                  <v-btn
                    class="green-mainBtn mx-2"
                    width="155"
                    height="40"
                    @click="openEditDialog(row.item)"
                    ><v-icon class="me-1">mdi-pencil-box-outline</v-icon
                    >ویرایش</v-btn
                  >
                  <v-btn
                    @click="openChangePassDialog(row.item)"
                    class="orange-mainBtn mx-2"
                    width="155"
                    height="40"
                    style="text-decoration: none"
                    ><v-icon class="me-1">mdi-lock-outline</v-icon>ویرایش رمز
                    عبور</v-btn
                  >
                </div>
              </template>
            </b-table>
            <v-row class="mt-6">
              <v-col>
                <div class="d-flex flex-row">
                  <span class="c-grey pt-2">نمایش در هر صفحه</span>
                  <div class="ms-3 me-3 number-box">
                    <v-select
                      outlined
                      v-model="perPage"
                      :items="perPageOptions"
                      @change="currentPage = 1"
                    ></v-select>
                  </div>
                </div>
              </v-col>
              <v-col class="d-flex flex-row">
                <span class="c-grey pt-2"> برو به صفحه </span>
                <div class="ms-3 me-3 number-box">
                  <v-select
                    outlined
                    v-model="whichPage"
                    type="number"
                    @change="goToPage()"
                    @click="goToPage()"
                    :items="computedIndex"
                  ></v-select>
                </div>
              </v-col>
              <v-col>
                <div>
                  <v-pagination
                    v-model="currentPage"
                    :length="Math.ceil(computedItems.length / perPage)"
                    :total-visible="5"
                    prev-icon="$ArrowLeft"
                    next-icon="$ArrowRight"
                    class="float-end"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-card>
    <v-dialog v-model="newEmployeeDialog" width="800">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">ثبت کارمند جدید</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="newEmployeeDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> نام کاربری:</label
              >
              <v-text-field
                placeholder="نام کاربری"
                outlined
                dense
                v-model="newEmployee.username"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> نام:</label
              >
              <v-text-field
                placeholder="نام"
                outlined
                dense
                v-model="newEmployee.name"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> نام خانوادگی:</label
              >
              <v-text-field
                placeholder="نام خانوادگی"
                outlined
                dense
                hide-details
                class="mb-2"
                v-model="newEmployee.lastName"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> ایمیل:</label>
              <v-text-field
                placeholder="ایمیل"
                outlined
                dense
                hide-details
                class="mb-2"
                v-model="newEmployee.email"
              ></v-text-field>
              <span class="red--text" v-if="!validateEmail(newEmployee.email)"
                >ایمیل وارد شده صحیح نمی‌باشد.</span
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">
                شماره موبایل:</label
              >
              <v-text-field
                placeholder="شماره موبایل"
                outlined
                dense
                hide-details
                type="number"
                v-model="newEmployee.mobile"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> نقش:</label
              >
              <v-select
                placeholder="نقش"
                outlined
                dense
                hide-details
                type="number"
                :items="roles"
                v-model="newEmployee.role"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> رمز عبور:</label
              >
              <v-text-field
                placeholder="رمز عبور"
                outlined
                dense
                hint="کاربر میتواند پس از لاگین رمز عبور خود را عوض کند"
                v-model="newEmployee.password"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <div class="text-left py-3 px-4">
          <v-btn
            class="red-mainBtn white--text mx-2"
            @click="newEmployeeDialog = false"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="AddEmployee()"
            :disabled="
              busy ||
              computedAddBtn ||
              (newEmployee.email && !validateEmail(newEmployee.email))
            "
            class="green-mainBtn white--text"
            width="90"
          >
            افزودن
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editEmployeeDialog" width="800">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">ویرایش کارمند</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="editEmployeeDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"> نام کاربری:</label>
              <v-text-field
                placeholder="نام کاربری"
                outlined
                dense
                disabled
                :loading="loading2"
                v-model="editEmployee.username"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> نام:</label
              >
              <v-text-field
                placeholder="نام"
                outlined
                dense
                hide-details
                :loading="loading2"
                v-model="editEmployee.name"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> نام خانوادگی:</label
              >
              <v-text-field
                placeholder="نام خانوادگی"
                outlined
                dense
                hide-details
                class="mb-2"
                :loading="loading2"
                v-model="editEmployee.lastName"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> ایمیل:</label>
              <v-text-field
                placeholder="ایمیل"
                outlined
                dense
                hide-details
                class="mb-2"
                :loading="loading2"
                v-model="editEmployee.email"
              ></v-text-field>
              <span
                class="red--text"
                v-if="
                  editEmployee.email != '-' &&
                  !validateEmail(editEmployee.email)
                "
                >ایمیل وارد شده صحیح نمی‌باشد.</span
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">
                شماره موبایل:</label
              >
              <v-text-field
                placeholder="شماره موبایل"
                outlined
                dense
                hide-details
                type="number"
                :loading="loading2"
                v-model="editEmployee.mobile"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> نقش:</label>
              <v-select
                placeholder="نقش"
                outlined
                dense
                hide-details
                :items="roles"
                type="number"
                v-model="editEmployee.role"
                :loading="loading2"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <label class="primary--text font-weight-bold"> وضعیت:</label>
              <v-select
                placeholder="وضعیت"
                outlined
                dense
                hide-details
                :items="statuses"
                :loading="loading2"
                v-model="editEmployee.status"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <div class="text-left py-3 px-4">
          <v-btn
            class="red-mainBtn white--text mx-2"
            @click="editEmployeeDialog = false"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="doEditEmployee()"
            :disabled="
              busy ||
              computedEditBtn ||
              (editEmployee.email.length > 0 &&
                editEmployee.email != '-' &&
                !validateEmail(editEmployee.email))
            "
            class="green-mainBtn white--text"
            width="90"
          >
            ویرایش
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="changePassDialog" width="600">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">
                ویرایش رمز عبور "{{ selectedEmployee.name }}
                {{ selectedEmployee.lastName }}"
              </h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2">
              <span class="pointer" @click="changePassDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-6" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col cols="12">
              <label class="primary--text font-weight-bold"> نام کاربری:</label>
              <v-text-field
                placeholder="نام کاربری"
                outlined
                dense
                disabled
                hide-details
                v-model="selectedEmployee.username"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <label class="primary--text font-weight-bold">
                رمز عبور جدید:</label
              >
              <v-text-field
                placeholder="رمز عبور جدید"
                outlined
                dense
                v-model="selectedEmployee.password"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <div class="text-left py-3 px-4">
          <v-btn
            class="red-mainBtn white--text mx-2"
            @click="changePassDialog = false"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="submitChangePassword()"
            :disabled="busy || !selectedEmployee.password"
            class="green-mainBtn white--text"
            width="90"
          >
            ثبت
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import { AtomSpinner } from "epic-spinners";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import md5 from "js-md5";

export default {
  components: {
    AtomSpinner,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      tab: null,
      moment: moment,
      filter: "",
      guide: false,
      busy: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [4, 10, 20],
      employee: [],
      newEmployee: {
        username: "",
        name: "",
        lastName: "",
        role: "",
        password: "",
      },
      editEmployee: {
        name: "",
        lastName: "",
        role: "",
        status: "",
        email: "",
      },
      selectedEmployee: {},
      newEmployeeDialog: false,
      editEmployeeDialog: false,
      changePassDialog: false,
      loading: false,
      loading2: false,
      employeesFields: [
        { key: "index", label: "ردیف" },
        { key: "username", label: "نام کاربری" },
        { key: "name", label: "نام" },
        { key: "lastName", label: "نام خانوادگی" },
        { key: "role", label: "نقش" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      roles: [
        { value: "Manager", text: "مدیر" },
        { value: "shop", text: "مسئول فروشگاه" },
        { value: "sales", text: "فروشنده" },
      ],
      statuses: [
        { value: "active", text: "فعال" },
        { value: "deactive", text: "غیرفعال" },
      ],
      whichPage: 1,
    };
  },
  methods: {
    goToPage() {
      this.currentPage = Number(this.whichPage);
    },
    checkNatCode(id) {
      return id ? (checkCodeMeli(id) ? true : false) : false;
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    openNewProduct() {
      this.newEmployeeDialog = true;
      this.guide = false;
    },
    openEditDialog(item) {
      this.selectedEmployee = item.id;
      this.getCustomerInfo();
      this.editEmployeeDialog = true;
    },
    openChangePassDialog(item) {
      this.selectedEmployee = item;
      this.changePassDialog = true;
    },
    getCustomerInfo() {
      this.loading2 = true;
      Axios.post(
        this.baseUrl + "/satrapp/users/id",
        {
          userId: this.selectedEmployee,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.editEmployee = res.data;
            this.loading2 = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
         
          this.toast(err.response.data, "error");
        });
    },
    showEmployee() {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/satrapp/users/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            this.employee = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
        });
    },
    AddEmployee() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/satrapp/users/new",
        {
          username: this.newEmployee.username,
          password: md5(this.newEmployee.password),
          name: this.newEmployee.name,
          lastName: this.newEmployee.lastName,
          email: this.newEmployee.email,
          mobile: this.newEmployee.mobile,
          role: this.newEmployee.role,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.newEmployee = {};
            this.newEmployeeDialog = false;
            this.showEmployee();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
    doEditEmployee() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/satrapp/users/edit",
        {
          userId: this.selectedEmployee,
          name: this.editEmployee.name,
          lastName: this.editEmployee.lastName,
          email: this.editEmployee.email,
          mobile: this.editEmployee.mobile,
          role: this.editEmployee.role,
          status: this.editEmployee.status,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.editEmployeeDialog = false;
            this.showEmployee();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.customerDialog = false;
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast(err.response.data, "error");
        });
    },
    submitChangePassword() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/satrapp/users/editPassword",
        {
          userId: this.selectedEmployee.id,
          password: md5(this.selectedEmployee.password),
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.toast(res.data, "success");
          this.changePassDialog = false;
          this.showEmployee();
          this.busy = false;
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
  },
  computed: {
    computedItems() {
      let filtered;
      filtered = this.employee.filter((x) => x.name.includes(this.filter));
      return filtered;
    },
    computedIndex() {
      let arr = [];
      let computedLength = this.computedItems.length;
      let arrlength = Math.ceil(computedLength / this.perPage);
      for (let i = 1; i <= arrlength; i++) {
        arr.push(i);
      }
      return arr;
    },
    computedAddBtn() {
      if (
        !this.newEmployee.username ||
        !this.newEmployee.name ||
        !this.newEmployee.lastName ||
        !this.newEmployee.role ||
        !this.newEmployee.password
      ) {
        return true;
      } else false;
    },
    computedEditBtn() {
      if (
        !this.editEmployee.name ||
        !this.editEmployee.lastName ||
        !this.editEmployee.role ||
        !this.editEmployee.status
      ) {
        return true;
      } else false;
    },
  },
  mounted() {
    this.showEmployee();
  },
};
</script>

<style lang="scss">
.employee {
  .sort-box {
    border-radius: 10px;
    padding: 7px 15px;
    color: #656a81;

    &.selected-sort {
      background-color: #00b4d8;
      color: #fff;
      &:hover {
        background-color: #00b4d8;
      }
    }
    &:hover {
      background-color: #eee;
    }
  }
  .orange-borderedBtn {
    background-color: #f4f4ff !important;
  }
}

.product-dialog-card {
  border-radius: 15px !important;
  padding: 10px;
  max-height: 680px;
  overflow-y: auto;
  .custom-input {
    .v-textarea {
      .v-input__slot {
        height: 246px !important;
      }
    }
    .v-input__slot {
      width: 100% !important;
    }
    .v-input__icon--append {
      padding-top: 3px !important;
      i {
        color: #ef6c00 !important;
        cursor: pointer;
      }
    }
  }
}
</style>
